export default {
  'm': {
    'EnterID': 'انقر لإدخال BuzzCast ID',
    'select-specifications': 'انقر لاختيار مواصفات الدفع',
    'check-account': 'مراجعة حساب الدفع',
    'whatID': 'ما هو BuzzCast ID',
    'getID': 'ادخل BuzzCast ID',
    'maskgetID': 'ادخل BuzzCast ID',
    'toastTips-format-error': ' إدخال غير صحيح',
    'toastTips-no-exist': 'IDغير موجود',
    'toastTipsPlease': 'يرجى التحقق من حساب الدفع أولاً',
    'common-problem': 'الأسئلة الشائعة',
    'transaction-succeeded': ' نجحت هذه الصفقة',
    'transaction-failed': 'فشلت هذه الصفقة',
    'transaction-cancel': 'إلغاء الصفقة',
    'whether-account': '1. كيف أتحقق مما إذا كان قد تم مبلغ الدفع بعد الدفع؟',
    'answer-whether-account': 'بعد الدفع، يمكنك العودة إلى [حسابي] - [محفطة] للتطبيق لعرض الالماس',
    'no-account': 'ماذا أفعل لو لم يصل مبلغ الحساب بعد الدفع؟2.',
    'answer-no-account': 'يرجى إرسال أسئلتك في تطبيق [الأخبار] - [الأخبار الرسمية] - [التعليقات والمساعدة]، وتوفير المعلومات التالية، سوف تساعدك خدمة العملاء لدينا.',
    'recharge-money': '1. مبلغ الدفع وحسابك',
    'recharge-time': '2. وقت وتاريخ الدفع',
    'recharge-shot': '3. لقطة شاشة للدفع الناجح.',
    'recharge-wrong': '3.ماذا أفعل إذا قمت بدفع لحساب خاطئ ودفع المبلغ الخاطئ؟',
    'answer-recharge-wrong': 'قبل إدخال كلمة مرور للدفع، يجب تأكيد هوية حساب الدفع ومبلغ بعناية قبل إجراء عملية الشراء. لا يمكن استرداد مبلغ الدفع الخاطئ. بالنسبة لحساب الدفع الخاطئ، يمكنك محاولة الاتصال بالمستخدم الذي دفعت بالفعل والتفاوض معه سواء كان على استعداد لتعويض دفعك.',
    'refund': '4.رد المال',
    'answer-refund': 'آسف! لا يدعم BuzzCast حاليًا أي شكل من رد الأموال.',
    'buy-enter-link': 'يمكن شراء الماس من خلال الرابط <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> انسخ الرابط في متصفح الجوال لفتحه، وأدخل صفحة الشراء، وبعد التحقق من الحساب، حدد المواصفات المقابلة واستخدم طريقة الدفع المناسبة للدفع ~ هناك كثير من الخصومات!',
    'buy-notice-a': 'ملاحظة: <a>{msg}</a>  هو الموقع الرسمي الوحيد لشراء الماس لـ BuzzCast',
    'replace': 'استبدل',
    'sureBtn': 'موافق',
    'pay-style': 'اختر طريقة الدفع ',
    'goBack': 'رجوع إلى الصفحة الرئيسية',
    'toastTips': 'ادخل BuzzCast ID',
    'rechargeFAQ_title': 'الأسئلة الشائعة',
    'PayStatusSuccess_title': ' نجحت هذه الصفقة',
    'PayStatusFail_title': 'فشلت هذه الصفقة',
    'PayStatusCancel_title': 'إلغاء الصفقة',
    'Diamonds_title': 'موقع الدفع الرسمي {msg} للألماس   ',
    'buy-notice': 'ملاحظة pay.buzzcast.info هو الموقع الرسمي الوحيد لشراء الماس من BuzzCast. لاستفسارات خدمة العملاء ، يرجى الانتقال إلى [رسالة] - [أخبار رسمية] - [ملاحظات ومساعدة]',
    'RechargeHelp_title': 'مساعدة إعادة الشحن',
    'openAPP': 'افتح تطبيق BuzzCast',
    'buy-diamonds-tit': 'شراء خدمات الماس',
    'description': 'إن BuzzCast موقع رسمي وحيد لدفع الماس ، BuzzCast هو برنامج اجتماعي دولي ، ويستخدمه المستخدمون في أكثر من 150 دولة ومنطقة حول العالم ',
    'keywords': 'BuzzCast لدفع،BuzzCast لدفع ألماس،BuzzCast لدفع الرسمي ،موقع BuzzCast للدفع الرسميللدفع الرسمي',
    'trueText': 'موافق',
    'falseText': 'إلغاء',
    'alertShowTxt1': 'هل أنت متأكد من استخدام',
    'alertShowTxt3': ' لإعادة شحن',
    'alertShowTxt5': ' الماس؟',
    'payforType': 'طريقة الشحن',
    //  إعادة شحن BuzzCast السريعإعادة شحن BuzzCast السريع
    'EnterIDTip': 'إعادة شحن {msg} السريع',
    'scanLogin': 'لخصوصية وأمان الحساب ، يرجى مسح الكود لتسجيل الدخول',
    'scanTip': '"نصيحة: انقرعلي المركز الشخصي / منشورة BuzzCast وعلي مسح الكود في الزاوية العليا,تسجيل الدخول ، ودعم أيضا تسجيل الدخول عن طريق لقطة الشاشة بتحديد كود الاستجابة السريعة"',
    //   تسجيل الدخول ، ودعم أيضا تسجيل الدخول عن طريق لقطة الشاشة بتحديد كود الاستجابة السريعة"
    'scanVersion': 'الرجاء ترقية BuzzCast إلى النسخة %s ومسح الكود لتسجيل الدخول',
    'delAccount': 'حذف الحساب',
    'logout': 'الخروج من تسجيل الدخول',
    'submit': 'تقديم',
    'email_place_holder': 'أدخل صندوق البريد الخاص بك',
    'contact_email': 'تتصل بالبريد الاكتروني',
    'provide_email': 'يرجى تقديم عنوان بريدك الإلكتروني لتستقبل إعلان الدفع',
    'email_address': 'عنوان البريد الاكتروني',
    'sel_country_area': 'اختر الدولة أو المنطقة',
    'search_for': 'بحث',
    'login': 'تسجيل الدخول',
    'scan_login': 'تسجيل الدخول بمسح الكود',
    'account_password_error': 'رقم الهاتف أو كلمة المرور غير صحيحة',
    'user_frozen': 'تم تجميد المستخدم',
    'account_no_reg': 'الحساب غير مسجل',
    'login_no': 'لم يتم تسجيل الدخول لك',
    'login_after_recharge': 'يمكنك إعادة الشحن بعد تسجيل الدخول',
    'scan_login_lesson': 'تعليم تسجيل الدخول بمسح الكود',
    'scan_login_desc': 'يمكن لطريقة تسجيل الدخول إلى رمز المسح الضوئي أن تدرك بسرعة وأمان تسجيل الدخول إلى موقع إعادة الشحن ، ستقدم الطريقتان التاليتان على التوالي كيفية مسح رمز الاستجابة السريعة لتسجيل الدخول.',
    'scan_login_a_title': 'قم بتسجيل الدخول من خلال تعرف رموز الكود على لقطات شاشة',
    'scan_login_a_p1': 'إنه أكثر ملاءمة لسيناريو استخدام جهاز واحد. يقوم المستخدم بإدخال صفحة تسجيل الدخول إلى موقع إعادة الشحن ، والنقر لتحديد "تسجيل الدخول إلى رمز الاستجابة السريعة" ، وسيتم عرض لقطة شاشة للصفحة مع رمز الاستجابة السريعة لتسجيل الدخول ، وسيتم عرض الألبوم تم الحفظ. (تختلف وظيفة لقطة الشاشة قليلاً بالنسبة للأجهزة المختلفة ، يمكنك البحث عن تعليمات تشغيل وظيفة لقطة الشاشة بنفسك)',
    'scan_login_a_p2': 'افتح تطبيق BuzzCast ، وانتقل إلى وحدة الوظيفة "المركز الشخصي" أو "لحظات" ، وانقر فوق "المسح" في الزاوية اليمنى العليا للدخول إلى وحدة وظيفة مسح الرمز.',
    'scan_login_a_p3': 'انقر على "اختيار الألبوم" واسمح لأذونات الألبوم. حدد لقطة الشاشة المحفوظة لصفحة تسجيل الدخول إلى رمز الاستجابة السريعة. بعد أن يتعرف النظام عليها ، انقر فوق زر التأكيد "تسجيل الدخول" ، ثم عد إلى المتصفح وانتظر لفترة من الوقت ، وستقوم الصفحة تحميل معلومات المستخدم تلقائيًا.',
    'scan_login_b_title': 'تسجيل الدخول عن طريق مسح رمز الاستجابة السريعة',
    'scan_login_b_p1': '1. هو أكثر ملاءمة لمشاهدات استخدام أجهزة متعددة. يقوم المستخدم بإدخال صفحة تسجيل الدخول الخاصة بموقع إعادة الشحن والنقر لتحديد "تسجيل الدخول إلى مسح الرموز"',
    'scan_login_b_p2': '2. افتح تطبيق BuzzCast على جهاز آخر ، وانتقل إلى وحدة الوظيفة "المركز الشخصي" أو "لحظات" ، وانقر فوق "مسح الرموز" في الزاوية اليمنى العليا للدخول إلى وحدة وظيفة مسح الرمز.',
    'scan_login_b_p3': '3. قم بمحاذاة مربع رمز المسح الضوئي مع رمز الاستجابة السريعة الموجود على صفحة تسجيل الدخول إلى مسح الرموز ، وانقر فوق زر تأكيد "تسجيل الدخول" بعد أن يتعرف عليه النظام (يوصى بالاحتفاظ بمسافة معينة بين الأجهزة عند مسح الرمز ضوئيا ، وهو يسهل على النظام التعرف عليه) ، وستصبح الصفحة تلقائيا بعد فترة من الوقت تحميل معلومات المستخدم.',
    'scan_login_lesson_end': 'ما سبق هو دليل تعليمي لمسح تسجيل الدخول بالرمز ، وآمل أن أساعدك، لاستفسارات خدمة العملاء ، يرجى إدخال رسالة APP - الأخبار الرسمية - التعليقات والمساعدة.',
    'or': 'أو',
    'input_phone_num': 'رقم الهاتف لا يمكن أن يكون فارغًا',
    'input_email': 'الرجاء إدخال عنوان البريد الإلكتروني الخاص بك',
    'input_password': 'أدخل كلمة المرور',
    'log_in_using_Facebook': 'تسجيل الدخول باستخدام Facebook',
    'log_in_using_Google': 'تسجيل الدخول باستخدام Google',
    'account_or_pwd_error': 'حساب أو كلمة مرور غير صحيحة',
    'pay_fail_system_risk': 'فشلت المعاملة: النظام غير طبيعي',
    'friendly_tip': 'نصائح',
    'i_got_it': 'حصلت عليه',
    'android_fblogin_tip': 'نظرًا لأن Facebook لم يعد يدعم تسجيل الدخول للمصادقة على متصفح Android المضمن ، فقد لا تتمكن من تسجيل الدخول عند تسجيل الدخول بهذه الطريقة. إذا واجهت هذا النوع من مشاكل تسجيل الدخول ، فالرجاء استخدام متصفح Chrome للوصول إليه.',
    'recharge_tip': 'العدد الحقيقي لماس  سيصل إلى حسابك  يخضع لمبلغ إعادة الشحن الحقيقي',
    'charge': 'الشحن',
    'link_add_mainpage': 'أضف رابطًا إلى الشاشة الرئيسية لإعادة الشحن المرة القادمة',
    'click_me_to_add': 'انقرانا للإضافة',
    'user_has_delete': 'هذا المستخدم تم تسجيل الخروج',
    'support_contant_whatsapp': 'إذا كنت بحاجة إلى دعم ، فيرجى الاتصال بخدمة العملاء على {msg} App：1924383',
    'buy_balance': 'الرصيد المتوفر:',
    'official_coin_seller': 'تاجر العملات الرسمي',
    'paystyle_unavailabel_change_other': 'النظام غير طبيعي ، طريقة الدفع هذه غير متاحة مؤقتًا ، يمكنك التغيير إلى طرق دفع أخرى.',
    'failedPay': 'مشكلة في الدفع',
    "copied": "تم النسخ",
    "reseller": "موزع",
    "netword_busy_try": "الشبكة مشغولة ، حاول اعادة",
    "placecommen": 'أدخل كلمات البحث',
    "app_all_v2": 'الكل',
    "use_phone_login": `تسجيل الدخول باستخدام الهاتف`,
    "use_email_login": `تسجيل الدخول باستخدام البريد الإلكتروني`,
    "device_is_more": "وصل عدد الحسابات المسجلة لهذا الجهاز إلى الحد الأقصى",
    "Operation_failed": "تم تجميد هذا الجهاز نهائيًا بسبب يخالف نظام التطبيق",
    "bondo_pay_tip": "The recharged balance can only be used in the app. Download and open the app to use your balance to unlock and watch paid episodes",
    "bondo_pay_success_tip": "Download Bondo from the App Store and sign in to both the app and the website with the same account. Once completed, any balance topped up on the website can be used in the app to unlock paid short-drama episodes",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/ar.js